app.factory('baseOfCaseService', ['$q', 'baseService', 'objectHelper', 'config', '$http',
    function($q, baseService, objectHelper, config, $http) {

        function BaseOfCaseService() {

            this.getAnonymizedData = function(request) {
                return baseService.post(config.API_URL + '/knowledgeBase/dataPage', request).then(
                    function(successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, VisitCardAnonymizedVO);
                        dataPage.data = objectHelper.convertTimesToDates(dataPage.data);

                        return dataPage;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAnonymizedStateOfHealth = function(idVisitCard) {
                return baseService.get(config.API_URL + '/knowledgeBase/' + idVisitCard + '/getAnonymizedStateOfHealth').then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, StateOfHealthAnonymizedWrapperVO);
                        data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAnonymizedVisitCard = function(idVisitCard) {
                return baseService.get(config.API_URL + '/knowledgeBase/' + idVisitCard).then(
                    function(successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, VisitCardAnonymizedVO);
                        dataPage.data = objectHelper.convertTimesToDates(dataPage);

                        return dataPage;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAnonymizedVisitHistory = function(idVisitCard, visitHistoryRequest) {
                return baseService.post(config.API_URL + '/knowledgeBase/' + idVisitCard + '/getVisitHistory', visitHistoryRequest).then(
                    function(successResponse) {
                        var dataPage = objectHelper.translateArray(successResponse, VisitAnonymizedVO);

                        return dataPage;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.uploadFile = function (file) {

                var formData = new FormData();
                formData.append('file', file);

                var req = {
                    method: 'POST',
                    url: config.API_URL + '/biDataImport/csvImport',
                    headers: { 'Content-Type': undefined },
                    data: formData
                };

                return $http(req).then(
                    function(successResponse) {
                        return objectHelper.translateObject(successResponse.data, AttachmentFileVO);
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );

            };

        }

        return new BaseOfCaseService();
    }
]);
